export class Auth {
  emailAddress: string;
  Password: string;

  constructor(values: object = {}) {
    Object.assign(this, values);
  }
}
